const KEY = 'mendsActiveContact';

export type ActiveContact = {
  sectorId: number;
  contactId: number;
  name: string;
};

export function rememberActiveContact(contact: {
  id: number;
  name?: string | null;
  sectorId?: number | null;
  isGroup?: boolean;
} | null): void {
  if (!contact || contact.isGroup || !contact.id) return;
  const sectorId = Number(contact.sectorId);
  if (!Number.isFinite(sectorId) || sectorId <= 0) return;
  const payload: ActiveContact = {
    sectorId,
    contactId: contact.id,
    name: (contact.name || 'Contato').trim() || 'Contato',
  };
  sessionStorage.setItem(KEY, JSON.stringify(payload));
}

export function readActiveContact(): ActiveContact | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ActiveContact>;
    const sectorId = Number(parsed.sectorId);
    const contactId = Number(parsed.contactId);
    if (!Number.isFinite(sectorId) || sectorId <= 0 || !Number.isFinite(contactId) || contactId <= 0) {
      return null;
    }
    return {
      sectorId,
      contactId,
      name: (parsed.name || 'Contato').trim() || 'Contato',
    };
  } catch {
    return null;
  }
}
